common.View.create('canvas.blocks.sky.contentBlog.Block', {

    onDOMLoad() {

        this.initSlider();
    },

    initSlider() {

        var logoOwl = this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            autoplay: false,
            // autoplayTimeout:2500,
            // autoplayHoverPause:true,
            responsive: {
                320: {
                    items: 1
                },
                640: {
                    items: 2
                },
                1000: {
                    items: 3
                },
            }
        });

    }
});
